export const EMPLOYEES_SET = "employeesSet";
export const EMPLOYEE_SET = "employeeSet";
export const EMPLOYEES_RESET = "employeesReset";
export const EMPLOYEE_RESET = "employeeReset";
export const SET_EMPLOYEE_ACTIVE = "setEmployeeActive"
export const SET_EMPLOYEE_PAGINATION = "setEmployeePagination"